import { render, staticRenderFns } from "./SetAvatar.vue?vue&type=template&id=ce6277b8&scoped=true"
import script from "./SetAvatar.vue?vue&type=script&lang=js"
export * from "./SetAvatar.vue?vue&type=script&lang=js"
import style0 from "./SetAvatar.vue?vue&type=style&index=0&id=ce6277b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6277b8",
  null
  
)

export default component.exports